// JavaScript source code
/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    ReferenceField,
    DateField,
    SimpleShowLayout,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import {
    AutocompleteInput,
    BooleanInput,
    TextInput,
} from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const CampusLocationLabels = {
    pageTitle: 'Campus Locations',
    name: 'Campus name',
    code: 'Campus code',
};

export const CampusLocationList = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={CampusLocationLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField
                        label={CampusLocationLabels.name}
                        source="Title"
                    />
                    <TextField
                        label={CampusLocationLabels.code}
                        source="code"
                    />
                </Datagrid>
            </SwList>{' '}
        </ReadOnlyContext.Provider>
    );
};

export const CampusLocationEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput disabled source="id" />
                    <TextInput label="Campus name" source="Title" />
                    <TextInput label="Campus code" source="code" />
                    <BooleanInput source="current" />
                    <TextInput source="hesAcode" />
                    <TextInput source="campusstatus_id" />
                    <ReferenceInput
                        label="DeliveryInstitution"
                        reference="DeliveryInstitution"
                        source="deliveryinstitution_id"
                    >
                        <AutocompleteInput optionText="Title" />
                    </ReferenceInput>
                    <TextInput disabled source="created_at" />
                    <TextInput disabled source="updated_at" />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};
//TODO: Add StatusCodeReference when API is added
/*<ReferenceInput label="StatusCode" reference="StatusCode" source="campusstatus_id">
        <SelectInput optionText="Title" />
    </ReferenceInput>*/

export const CampusLocationCreate = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Create {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput label="Campus name" source="Title" />
                    <TextInput label="Campus code" source="code" />
                    <BooleanInput source="current" />
                    <TextInput source="hesAcode" />
                    <TextInput source="campusstatus_id" />
                    <ReferenceInput
                        label="DeliveryInstitution"
                        reference="DeliveryInstitution"
                        source="deliveryinstitution_id"
                        allowEmpty
                    >
                        <AutocompleteInput optionText="Title" />
                    </ReferenceInput>
                </SimpleForm>
            </Create>
        </ReadOnlyContext.Provider>
    );
};
//TODO: Add StatusCodeReference when API is added
/*<ReferenceInput label="StatusCode" reference="StatusCode" source="campusstatus_id">
    //    <SelectInput optionText="Title" />
    </ReferenceInput>*/

export const CampusLocationShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Campus name" source="Title" />
            <TextField label="Campus code" source="code" />
            <BooleanField source="current" />
            <TextField source="hesAcode" />
            <TextField source="campusstatus_id" />
            <ReferenceField
                label="DeliveryInstitution"
                reference="DeliveryInstitution"
                source="deliveryinstitution_id"
                allowEmpty
            >
                <TextField optionText="Title" />
            </ReferenceField>
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
//TODO: Add StatusCodeReference when API is added
/*<ReferenceField label="StatusCode" reference="StatusCode" source="campusstatus_id">
        <TextField optionText="Title" />
    </ReferenceField>*/
